// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PublishDraftScheduleStepperQueryVariables = Types.Exact<{
  scheduleParentId: Types.Scalars['ID']['input'];
}>;


export type PublishDraftScheduleStepperQuery = { __typename?: 'Query', planSchedule: { __typename?: 'PlanSchedule', id: string, canSendTradePartnerAvailabilityRequestEmail: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };


export const PublishDraftScheduleStepperDocument = gql`
    query PublishDraftScheduleStepper($scheduleParentId: ID!) {
  planSchedule(idOrScheduleParentId: $scheduleParentId) {
    id
    canSendTradePartnerAvailabilityRequestEmail {
      ...PotentialOperationDetails
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;

/**
 * __usePublishDraftScheduleStepperQuery__
 *
 * To run a query within a React component, call `usePublishDraftScheduleStepperQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishDraftScheduleStepperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishDraftScheduleStepperQuery({
 *   variables: {
 *      scheduleParentId: // value for 'scheduleParentId'
 *   },
 * });
 */
export function usePublishDraftScheduleStepperQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables> & ({ variables: PublishDraftScheduleStepperQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>(PublishDraftScheduleStepperDocument, options);
      }
export function usePublishDraftScheduleStepperLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>(PublishDraftScheduleStepperDocument, options);
        }
export function usePublishDraftScheduleStepperSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>(PublishDraftScheduleStepperDocument, options);
        }
export type PublishDraftScheduleStepperQueryHookResult = ReturnType<typeof usePublishDraftScheduleStepperQuery>;
export type PublishDraftScheduleStepperLazyQueryHookResult = ReturnType<typeof usePublishDraftScheduleStepperLazyQuery>;
export type PublishDraftScheduleStepperSuspenseQueryHookResult = ReturnType<typeof usePublishDraftScheduleStepperSuspenseQuery>;
export type PublishDraftScheduleStepperQueryResult = Apollo.QueryResult<PublishDraftScheduleStepperQuery, PublishDraftScheduleStepperQueryVariables>;